import React from 'react';
import { useTheme } from 'emotion-theming';

export default ({ colour }: { colour?: string }): JSX.Element => {
    const theme = useTheme();
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.20101 12.568H10.799C10.799 9.763 13.74 10.222 13.74 7.111C13.74 5.326 12.414 4 10 4C7.73901 4 6.34501 5.394 6.26001 7.451H7.92601C8.01101 6.21 8.69101 5.53 10.085 5.53C11.377 5.53 12.074 6.227 12.074 7.196C12.074 9.474 9.20101 8.964 9.20101 12.568ZM10 16.172C10.697 16.172 11.19 15.645 11.19 14.982C11.19 14.319 10.697 13.792 10 13.792C9.30301 13.792 8.81001 14.319 8.81001 14.982C8.81001 15.645 9.30301 16.172 10 16.172Z"
                fill={colour || theme.colours.darkGray}
            />
            <path
                d="M10 1.42859C14.7257 1.42859 18.5714 5.27332 18.5714 10C18.5714 14.7257 14.7257 18.5714 10 18.5714C5.27332 18.5714 1.42856 14.7257 1.42856 10C1.42856 5.27332 5.27332 1.42859 10 1.42859ZM10 0C4.47714 0 0 4.47711 0 10C0 15.5229 4.47714 20 10 20C15.5228 20 20 15.5229 20 10C20 4.47711 15.5228 0 10 0Z"
                fill={colour || theme.colours.darkGray}
            />
        </svg>
    );
};
